import { Star } from 'lucide-react';

const RATING_STEPS = [
  { id: 'first-star', value: 1 },
  { id: 'second-star', value: 2 },
  { id: 'third-star', value: 3 },
  { id: 'fourth-star', value: 4 },
  { id: 'fifth-star', value: 5 },
];

export const RatingStars = ({ rating }) => RATING_STEPS
  .filter(({ value }) => value <= rating)
  .map(({ id }) => <Star key={id} className="w-5 h-5 text-yellow-400 fill-yellow-400" />);